export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';
export const GET_REPORT_URL_FAILURE = 'GET_REPORT_URL_FAILURE';
export const GET_REPORT_URL_REQUEST = 'GET_REPORT_URL_REQUEST';
export const GET_REPORT_URL_SUCCESS = 'GET_REPORT_URL_SUCCESS';
